// extracted by mini-css-extract-plugin
export default {"containerBar":"BottomCarSearch_containerBar__WuimO"};